import { Backdrop, Button, InputAdornment, TextField } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/Hooks";
import { useSearchParams } from "react-router-dom";
import { IOrderDetailMaster, IOrderItemDetail } from "./IOrderDetailMaster";

import { raise_api_call_list_general_setting } from "../../redux/general-setting/list-general-setting-reducer";
import OrderDetailMasterList from "./OrderDetailMasterList";
import { clearCreateItemDetailMaster } from "../../redux/itemdetail-master/createItemDetailMaster";
import { clearEditItemDetailMaster } from "../../redux/itemdetail-master/editItemDetailMaster";
import { listItemDetailMasterStart } from "../../redux/itemdetail-master/listItemDetailMaster";
import { listOrderDetailMasterStart } from "../../redux/orderdetail-master/listOrderDetailMaster";
import { clearCreateOrderDetailMaster } from "../../redux/orderdetail-master/createOrderDetailMaster";
import { clearEditOrderDetailMaster } from "../../redux/orderdetail-master/editOrderDetailMaster";
import { listRetailerMasterStart } from "../../redux/retail-master/listRetailerMaster";
import OrderDetailMasterForm from "./OrderDetailMasterForm";
import {
  listDistributorMasterStart,
  clearListDistributorMaster,
} from "../../redux/distributor-master/listDistributorMaster";
import { clearListOrderDetailItemMaster } from "../../redux/orderdetail-master/searchOrderDetailItems";
import { useCommonContext } from "../../Utils/commonContext";
import SearchImg from "../../assets/images/search.svg";
import DataNotFound from "../../assets/images/no_data_found.svg";

const OrderDetailMaster: FunctionComponent = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [orderDetail, setOrderDetail] = useState<IOrderDetailMaster>({});
  const [search, setSearch] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<IOrderDetailMaster>({
    active: true,
  });
  const [isEdit, setEdit] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { setTitleContext, setShowBack, setOnBackClick, isMobile } =
    useCommonContext();
  const { data: orderDetailList, isLoading: listOrderDetailLoading } =
    useAppSelector((state) => state.ListOrderDetailMaster);

  const { data: createOrderDetail } = useAppSelector(
    (state) => state.CreateOrderDetailMaster
  );

  const { data: editOrderDetail } = useAppSelector(
    (state) => state.EditOrderDetailMaster
  );
  const listOrderDetail =
    orderDetailList?.result?.map((orderDetail, index) => ({
      ...orderDetail,
      index: index + 1,
    })) ?? [];

  const handleClickOpen = () => {
    setTitleContext("Add");
    setOpen(true);
    setShowBack(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEdit(false);
  };
  // list render
  useEffect(() => {
    dispatch(listOrderDetailMasterStart(null));
  }, [createOrderDetail, editOrderDetail]);

  //clear create edit data and get the state list
  useEffect(() => {
    dispatch(raise_api_call_list_general_setting(""));
    dispatch(listItemDetailMasterStart(null));
    dispatch(listRetailerMasterStart(null));
    dispatch(listDistributorMasterStart(null));
    return () => {
      dispatch(clearCreateOrderDetailMaster());
      dispatch(clearEditOrderDetailMaster());
      dispatch(clearListDistributorMaster());
      dispatch(clearListOrderDetailItemMaster());
    };
  }, []);

  useEffect(() => {
    if (listOrderDetail?.length !== 0) {
      const orderDetailCheckById =
        searchParams.get("id") &&
        listOrderDetail?.find(
          (item) => item.id === Number(searchParams.get("id"))
        );

      if (orderDetailCheckById) {
        const order_details = orderDetailCheckById.order_detail?.reduce(
          (accumulater: IOrderItemDetail[], currentValue) => {
            const findVal = accumulater.find(
              (data) =>
                data.style === currentValue.style &&
                data.color === currentValue.color
            );
            if (findVal) {
              findVal.qty_sizes?.push(currentValue);
            } else {
              accumulater.push({ ...currentValue, qty_sizes: [currentValue] });
            }
            return accumulater;
          },
          []
        );
        console.log("data", order_details);

        setOrderDetail({
          ...orderDetailCheckById,
          order_detail: order_details,
        });
      } else {
        setOrderDetail({});
      }
    }
  }, [
    searchParams.get("id"),
    listOrderDetail?.length,
    createOrderDetail,
    editOrderDetail,
  ]);

  const handleBack = () => {
    setOpen(false);
    setOrderDetail({});
    setShowBack(false);
    setTitleContext("Order Detail");
  };

  useEffect(() => {
    setOnBackClick(() => handleBack);
    return () => {
      setOpen(false);
      setShowBack(false);
      setTitleContext("");
    };
  }, []);

  useEffect(() => {
    if (orderDetail.retail?.name) {
      setShowBack(true);
    }
  }, [orderDetail]);

  useEffect(() => {
    setTitleContext(
      orderDetail.retail?.name ?? (open ? "Add" : "Order Detail")
    );
  }, [orderDetail]);

  return (
    <div className="partner-details">
      {!open ? (
        <div className={`content_container`}>
          <div
            className={`mini_side_container`}
            style={{
              display: isMobile && orderDetail.id ? "none" : "initial",
            }}
          >
            <h5 className="f4 primary_text" style={{ paddingBottom: "10px" }}>
              Retailer Master
            </h5>

            <div className="side_search_container">
              <TextField
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                placeholder="Search"
                className="side_search"
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={SearchImg} alt="search" width="20px" />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: "0px",
                    height: "45px",
                  },
                }}
              />
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  dispatch(listOrderDetailMasterStart(null));
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "arrows-rotate"]}
                />
              </Button>
              <Button
                className="side_filter"
                disableRipple
                onClick={() => {
                  handleClickOpen();
                }}
              >
                <FontAwesomeIcon
                  style={{
                    fontSize: "22px",
                    color: "var(--white-color)",
                  }}
                  icon={["fas", "add"]}
                />
              </Button>
            </div>

            <div className="side_content_container">
              {listOrderDetail &&
                listOrderDetail
                  .filter((item) => {
                    return Object.values(item)
                      .join("")
                      .toLowerCase()
                      .includes(search.toLowerCase());
                  })
                  .map((val, key) => (
                    <div
                      key={key + 1}
                      className={`side_content_card`}
                      onClick={() => {
                        val.id && setSearchParams({ id: val.id?.toString() });
                      }}
                    >
                      <div
                        className={`side_content_mini_card ${
                          orderDetail.id === val.id ? "active" : ""
                        }`}
                      >
                        <div className="side_content_footer side_content_footer2">
                          <div className="f4 title">{val.retail?.name}</div>
                          <FontAwesomeIcon
                            className="mx-2"
                            style={{
                              fontSize: "18px",
                              cursor: "pointer",
                              display:
                                orderDetail.id === val.id ? "flex" : "none",
                              color: "var(--black-color)",
                            }}
                            icon={["fas", "pen-to-square"]}
                            onClick={() => {
                              handleClickOpen();
                              setInitialValues(orderDetail ?? {});
                            }}
                          />
                        </div>
                        <div className="side_content_footer side_content_footer2 mt-2">
                          <h4 className="f4 subtitle">{val.order_no}</h4>
                          <h4 className={`f5 side_status active_sts`}>
                            {val?.entrydate
                              ? new Date(val.entrydate).toLocaleDateString()
                              : ""}
                          </h4>
                        </div>
                      </div>
                      {/* <FontAwesomeIcon
                              className="mx-2"
                              style={{
                                fontSize: "22px",
                                cursor: "pointer",
                                display:
                                  orderDetail.id === val.id ? "flex" : "none",
                              }}
                              icon={["fas", "pen-to-square"]}
                              onClick={() => {
                                handleClickOpen();
                                setInitialValues(orderDetail ?? {});
                              }}
                            /> */}
                    </div>
                  ))}
            </div>
          </div>

          <div
            className={`mini_content_container`}
            style={{
              display: isMobile && !orderDetail.id ? "none" : "initial",
            }}
          >
            {Object.keys(orderDetail).length === 0 ? (
              <div className="not_found_container">
                <img src={DataNotFound} alt="" />
                Please Select Any One Partner
              </div>
            ) : (
              <OrderDetailMasterList orderDetail={orderDetail} />
            )}
          </div>
        </div>
      ) : (
        <OrderDetailMasterForm
          open={open}
          initialValues={initialValues}
          handleClose={handleClose}
          setInitialValues={setInitialValues}
        />
      )}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={!!listOrderDetailLoading}
      >
        <img
          style={{
            height: "150px",
          }}
          src={require("../../assets/images/3.gif")}
        ></img>
      </Backdrop>
    </div>
  );
};

export default OrderDetailMaster;
